<app-loader></app-loader>

<!-- ============================================================
     LUCKYCREST — SOVEREIGN ROYAL PASS HEADER (AUTHENTICATED & VISITOR)
     Identical Pre-Login Aesthetic Architecture
     Obsidian (#030204) + Deep Burgundy (#C71650) + Champagne Gold (#E7CA96)
     ============================================================ -->

<!-- MOBILE FLOATING DOCK ( < 800px ) -->
<header
  *ngIf="isScreenWidthLessThan800() && !isTreasurePickRoute()"
  class="lc-pass-mobile z-[998] w-full"
>
  <!-- Authenticated Mobile Header -->
  <ng-container *ngIf="isDashboardRoute(); else mobileLandingHeader">
    <div class="lc-mobile-pass-frame">

      <!-- Left: Sidebar Trigger & Brand Crest -->
      <div class="flex items-center gap-2 min-w-0">
        <button
          type="button"
          (click)="toggleSidebar($event)"
          class="lc-mobile-trigger"
          aria-label="Toggle Sidebar Menu"
        >
          <span class="bar bar-1"></span>
          <span class="bar bar-2"></span>
          <span class="bar bar-3"></span>
        </button>

        <a routerLink="/dashboard/home" class="lc-mobile-brand" aria-label="Luckycrest">
          <div class="lc-mobile-crest">
            <div class="lc-crest-poly"></div>
            <img src="/mainLogo.webp" alt="Luckycrest" class="lc-mobile-logo" />
          </div>
        </a>
      </div>

      <!-- Center-Right: Floating Cashier Pod -->
      <div class="lc-mobile-cashier" (click)="RedirectToWallet()">
        <div class="lc-m-stack">
          <span class="lc-m-lbl">VAULT</span>
          <span class="lc-m-val">${{ showBalance ? (walletAmount | number: '1.2-2') : '••••' }}</span>
        </div>

        <button
          type="button"
          class="lc-m-plus"
          (click)="RedirectToWallet(); $event.stopPropagation()"
          aria-label="Quick Deposit"
        >
          +
        </button>
      </div>

      <!-- Right Utility Actions -->
      <div class="flex items-center gap-1.5 flex-shrink-0">
        <button
          type="button"
          (click)="toggleMusic()"
          class="lc-mobile-orb"
          [attr.aria-label]="isMuted ? 'Unmute' : 'Mute'"
        >
          <i *ngIf="isMuted" class="fa fa-volume-mute text-xs text-[#E7CA96]"></i>
          <i *ngIf="!isMuted" class="fa fa-volume-up text-xs text-[#E7CA96]"></i>
        </button>

        <button
          type="button"
          (click)="toggleNotifications()"
          class="lc-mobile-orb"
          aria-label="Notifications"
        >
          <i class="fas fa-bell text-xs text-[#FAF4EB]"></i>
          <span
            *ngIf="notificationCount > 0 || notifications.length > 0"
            class="lc-m-badge"
          >
            {{
              (notificationCount || notifications.length) >= 10
                ? "9+"
                : notificationCount || notifications.length
            }}
          </span>
        </button>

        <app-notifications
          *ngIf="showNotifications"
          [notifications]="notifications"
          (closeNotification)="showNotifications = false"
          (notificationsCount)="receiveNotificationCount($event)"
          (openChat)="handleOpenChat()"
        ></app-notifications>
      </div>

    </div>
  </ng-container>

  <!-- Visitor Mobile Header -->
  <ng-template #mobileLandingHeader>
    <div class="lc-mobile-pass-frame">
      <a routerLink="/" class="lc-mobile-brand">
        <div class="lc-mobile-crest">
          <div class="lc-crest-poly"></div>
          <img src="/mainLogo.webp" alt="Luckycrest" class="lc-mobile-logo" />
        </div>
        <span class="font-serif text-sm font-semibold text-[#F6E9D5] tracking-wide ml-1.5">
          LUCKY<span class="text-[#E7CA96]">CREST</span>
        </span>
      </a>

      <div class="flex items-center gap-2">
        <button
          type="button"
          (click)="redirectToLogin()"
          class="mobile-enter-btn"
        >
          LOGIN
        </button>

        <button
          (click)="toggleMobileMenu()"
          class="lc-mobile-orb"
          aria-label="Menu"
        >
          <svg class="w-4 h-4 text-[#FAF4EB]" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path *ngIf="!isMobileMenuOpen" d="M4 6h16M4 12h16M4 18h16" />
            <path *ngIf="isMobileMenuOpen" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Mobile Drawer for Visitors -->
    <div *ngIf="isMobileMenuOpen" class="landing-portal-menu">
      <ul class="space-y-2">
        <li><a routerLink="/dashboard/home" class="portal-link"><i class="fas fa-gamepad text-[#E7CA96]"></i> Games Lobby</a></li>
        <li><a routerLink="/dashboard/spinner" class="portal-link"><i class="fas fa-dharmachakra text-[#E7CA96]"></i> Spin Wheel</a></li>
        <li><a routerLink="/dashboard/scratch" class="portal-link"><i class="fas fa-gem text-[#E7CA96]"></i> Scratch Cards</a></li>
        <li><a routerLink="/dashboard/Terms&Conditions" class="portal-link"><i class="fas fa-file-contract text-[#FAF4EB]"></i> Terms</a></li>
        <li class="pt-2">
          <button type="button" (click)="redirectToLogin()" class="portal-enter-btn">
            ENTER CASINO VAULT
          </button>
        </li>
      </ul>
    </div>
  </ng-template>
</header>


<!-- DESKTOP SOVEREIGN PASS DOCK ( >= 800px ) -->
<header
  *ngIf="!isScreenWidthLessThan800() && !isTreasurePickRoute()"
  class="lc-pass-desktop z-[999] w-full"
>
  <div class="lc-pass-dock">
    <div class="lc-pass-frame">

      <!-- ========================================================
           LEFT POD: SIDEBAR TOGGLE & PRESTIGE BRAND CREST
           ======================================================== -->
      <div class="lc-pass-left">
        <!-- Sidebar Toggle Trigger -->
        <button
          *ngIf="isDashboardRoute()"
          type="button"
          (click)="toggleSidebar($event)"
          class="lc-pass-toggle"
          title="Toggle Sidebar Menu"
          aria-label="Toggle Sidebar"
        >
          <div class="lc-hamburger">
            <span class="ham-line"></span>
            <span class="ham-line ham-line--accent"></span>
            <span class="ham-line"></span>
          </div>
        </button>

        <!-- Sovereign Brand Crest Lockup (Pre-Login Mirror Style) -->
        <a [routerLink]="isDashboardRoute() ? '/dashboard/home' : '/'" class="lc-pass-brand" aria-label="Luckycrest Home">
          <div class="lc-pass-crest">
            <div class="lc-crest-shape"></div>
            <img src="/mainLogo.webp" alt="Luckycrest emblem" class="lc-brand-logo" />
            <span class="lc-crest-star">✦</span>
          </div>
          <div class="lc-brand-copy">
            <span class="lc-brand-wordmark">
              LUCKY<span>CREST</span>
            </span>
            <span class="lc-brand-sub">
              {{ isDashboardRoute() ? 'SOVEREIGN VAULT' : 'EXCLUSIVE SALON' }}
            </span>
          </div>
        </a>

        <!-- Live Status Pill -->
        <div class="lc-live-pill" title="Server Status: Online & Encrypted">
          <span class="live-dot"></span>
          <span class="live-text">LIVE</span>
        </div>
      </div>


      <!-- ========================================================
           CENTER POD: CASHIER DOCK (AUTHENTICATED) OR NAV (VISITOR)
           ======================================================== -->
      <div class="lc-pass-center">
        <!-- Authenticated Cashier Dock -->
        <ng-container *ngIf="isDashboardRoute(); else visitorNav">
          <div class="lc-cashier-dock">

            <!-- Real Cash Vault -->
            <div class="lc-wallet-cell" (click)="RedirectToWallet()" title="Real Balance - Click to Open Cashier">
              <div class="lc-cell-badge lc-cell-badge--gold">
                <svg viewBox="0 0 24 24" fill="currentColor" class="w-3.5 h-3.5">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 14.93V18h-2v-1.07c-1.9-.3-3.4-1.63-3.59-3.43h1.84c.18.99 1.05 1.7 2.25 1.7 1.25 0 2-.69 2-1.5 0-.79-.58-1.28-1.92-1.65-2.06-.57-3.08-1.5-3.08-2.95 0-1.53 1.25-2.73 3-2.95V5h2v1.07c1.61.27 2.94 1.45 3.23 3.03h-1.84c-.23-.84-.96-1.3-1.89-1.3-1.09 0-1.75.64-1.75 1.35 0 .66.52 1.13 1.83 1.5 2.23.63 3.17 1.57 3.17 3.1 0 1.62-1.3 2.87-3.09 3.08z"/>
                </svg>
              </div>
              <div class="lc-cell-info">
                <div class="lc-cell-top">
                  <span class="lc-cell-lbl">REAL WALLET</span>
                  <button
                    type="button"
                    class="lc-eye-btn"
                    (click)="toggleBalance(); $event.stopPropagation()"
                    title="Toggle Balance Visibility"
                  >
                    <fa-icon [icon]="showBalance ? Eye : EyeSlash" class="text-[9px]"></fa-icon>
                  </button>
                </div>
                <span class="lc-cell-val">${{ showBalance ? (walletAmount | number: '1.2-2') : '••••••••' }}</span>
              </div>
            </div>

            <span class="lc-dock-divider" aria-hidden="true"></span>

            <!-- Royal Bonus Reserve -->
            <div class="lc-wallet-cell" (click)="RedirectToWallet()" title="Bonus Balance">
              <div class="lc-cell-badge lc-cell-badge--ruby">
                <svg viewBox="0 0 24 24" fill="currentColor" class="w-3.5 h-3.5">
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                </svg>
              </div>
              <div class="lc-cell-info">
                <span class="lc-cell-lbl lc-cell-lbl--bonus">ROYAL BONUS</span>
                <span class="lc-cell-val lc-cell-val--bonus">${{ showBalance ? (bonusWalletAmount | number: '1.2-2') : '••••••••' }}</span>
              </div>
            </div>

            <!-- Instant Deposit CTA -->
            <button
              type="button"
              class="lc-deposit-btn group"
              (click)="RedirectToWallet()"
              aria-label="Open Cashier & Deposit"
            >
              <span class="lc-deposit-laser"></span>
              <span class="lc-deposit-plus">+</span>
              <span class="lc-deposit-txt">DEPOSIT</span>
              <i class="fas fa-bolt lc-deposit-bolt"></i>
            </button>

          </div>
        </ng-container>

        <!-- Visitor Navigation Links -->
        <ng-template #visitorNav>
          <nav class="flex items-center gap-8 px-4">
            <a routerLink="/dashboard/home" class="visitor-nav-link">GAMES</a>
            <a routerLink="/dashboard/spinner" class="visitor-nav-link">SPIN WHEEL</a>
            <a routerLink="/dashboard/scratch" class="visitor-nav-link">SCRATCH</a>
            <a routerLink="/dashboard/Terms&Conditions" class="visitor-nav-link">RULES</a>
          </nav>
        </ng-template>
      </div>


      <!-- ========================================================
           RIGHT POD: VIP IDENTITY & CONTROLS
           ======================================================== -->
      <div class="lc-pass-right">

        <ng-container *ngIf="isDashboardRoute(); else visitorRight">
          <!-- Audio Sonic Orb -->
          <button
            type="button"
            (click)="toggleMusic()"
            class="lc-orb-btn"
            [title]="isMuted ? 'Audio Muted — Click to Play' : 'Audio Active — Click to Mute'"
            [attr.aria-label]="isMuted ? 'Unmute' : 'Mute'"
          >
            <i *ngIf="isMuted" class="fa fa-volume-mute text-[#E7CA96]"></i>
            <i *ngIf="!isMuted" class="fa fa-volume-up text-[#E7CA96]"></i>
          </button>

          <!-- Notification Bell Orb -->
          <button
            type="button"
            (click)="toggleNotifications()"
            class="lc-orb-btn"
            title="Notifications & Alerts"
            aria-label="Notifications"
          >
            <i class="fas fa-bell text-[#FAF4EB]"></i>
            <span
              *ngIf="notificationCount > 0 || notifications.length > 0"
              class="lc-ruby-badge"
            >
              {{
                (notificationCount || notifications.length) >= 10
                  ? "9+"
                  : notificationCount || notifications.length
              }}
            </span>
          </button>

          <!-- VIP Player Profile Pill & Dropdown -->
          <div class="lc-profile-wrapper">
            <button
              type="button"
              (click)="toggleDropdown($event)"
              class="lc-profile-pill"
              [class.is-open]="isDropdownOpen"
              aria-label="User Profile"
            >
              <div class="lc-avatar-wrap">
                <img
                  [src]="profileImage"
                  alt="Avatar"
                  class="lc-avatar-img"
                  onerror="this.src = '/avatar.png'"
                />
                <span class="lc-avatar-status"></span>
              </div>

              <div class="lc-user-col">
                <span class="lc-user-name">{{ username || "@player" | slice: 0 : 12 }}</span>
                <span class="lc-user-tier">
                  <fa-icon [icon]="Crown" class="text-[#E7CA96] text-[8px] mr-1"></fa-icon>
                  {{ playerLevelName || "VIP I" }}
                </span>
              </div>

              <i class="fas fa-chevron-down lc-chevron" [class.rotate-180]="isDropdownOpen"></i>
            </button>

            <!-- Dropdown Dossier Menu -->
            <div *ngIf="isDropdownOpen" class="lc-profile-dropdown">
              <div class="lc-dropdown-inner">
                <div class="lc-dropdown-user">
                  <div class="lc-dropdown-avatar">
                    <img [src]="profileImage" alt="Avatar" onerror="this.src = '/avatar.png'" />
                  </div>
                  <div class="lc-dropdown-meta">
                    <span class="lc-meta-name">{{ username || "@player" }}</span>
                    <span class="lc-meta-rank">{{ playerLevelName || "Royal Member" }}</span>
                  </div>
                </div>

                <div class="lc-dropdown-sep"></div>

                <button type="button" class="lc-dropdown-item" (click)="saveUserProfileImage()">
                  <i class="fas fa-user-circle lc-item-icon"></i>
                  <span class="lc-item-txt">My Profile</span>
                  <i class="fas fa-chevron-right lc-item-arr"></i>
                </button>

                <button type="button" class="lc-dropdown-item" (click)="redirecttoTermsConditions()">
                  <i class="fas fa-shield-alt lc-item-icon"></i>
                  <span class="lc-item-txt">Rules & Protocol</span>
                  <i class="fas fa-chevron-right lc-item-arr"></i>
                </button>

                <div class="lc-dropdown-sep"></div>

                <button type="button" class="lc-dropdown-item lc-dropdown-item--danger" (click)="showLogoutModal()">
                  <i class="fas fa-power-off lc-item-icon"></i>
                  <span class="lc-item-txt">Logout</span>
                  <i class="fas fa-chevron-right lc-item-arr"></i>
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Visitor CTA -->
        <ng-template #visitorRight>
          <button
            type="button"
            (click)="redirectToLogin()"
            class="visitor-login-btn"
          >
            <span>ENTER VAULT</span>
            <i class="fas fa-key ml-2 text-xs"></i>
          </button>
        </ng-template>

      </div>

    </div>
  </div>
</header>

<!-- Modals Preserved -->
<app-logoutmodel
  [isOpen]="isLogoutModalOpen"
  [profileImage]="profileImage"
  (onCancel)="closeLogoutModal()"
  (onConfirm)="logout()"
></app-logoutmodel>

<app-deleteaccountmodel
  [isOpen]="isdeleteaccountmodelopen"
  [profileImage]="profileImage"
  (onCancel)="closedeleteaccountmodal()"
  (onConfirm)="deleteaccount($event)"
></app-deleteaccountmodel>

<app-kyc-popup *ngIf="showKycPopup" (close)="closeKycPopup()"></app-kyc-popup>

<!-- Notifications Modal -->
<app-notifications
  *ngIf="showNotifications && !isScreenWidthLessThan800()"
  [notifications]="notifications"
  (closeNotification)="showNotifications = false"
  (notificationsCount)="receiveNotificationCount($event)"
  (openChat)="handleOpenChat()"
></app-notifications>
